import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors'
import { MeetingInviteContainer } from '../../../employees/MeetingInviteContainer'
import useEmployeeDisplayTiny from '../../../../graphql/employee/hooks/useEmployeeDisplayTiny'
import PerSpacer from '../../../../components/custom_components/Spacer'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerButton from '../../../../components/custom_components/Button'

type InviteEmployeeMeetingTileProps = {
  employeeId: string
}

export const InviteEmployeeMeetingTile: FC<InviteEmployeeMeetingTileProps> = ({ employeeId }) => {
  const [t] = useTranslation()
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | null>(null)

  const { data, error, loading } = useEmployeeDisplayTiny(employeeId)

  if (loading || error || !data || !data.employeeDisplayTinyInfoByEmployeeId) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.employeeDisplayTinyInfoByEmployeeId} error={error} />
  }
  const employee = data.employeeDisplayTinyInfoByEmployeeId

  return (
    <>
      <PerSpacer mt="xs" mb="xxs">
        <PerFlexRow align="middle" className="meetingTile">
          {t('dashboard.employee.meetings.managerInviteEmployeeOptionText', {
            employeeName: employee.firstName,
          })}
        </PerFlexRow>
      </PerSpacer>
      <PerFlexRow align="bottom" className="meetingTile">
        <PerButton
          onClick={(e) => {
            e.preventDefault() // We should refactor button to not emit native event!
            setSelectedEmployeeId(employeeId)
          }}
          color="primary"
          variant="pastel"
          text={t('meetingInvite.headlineEmployeeInvite', { employee: employee.firstName })}
          before="invite_fill"
          size="small"
          mt="xxs"
          width="fullWidth"
        />
      </PerFlexRow>{' '}
      {selectedEmployeeId && (
        <MeetingInviteContainer
          employeeId={selectedEmployeeId}
          closeDialog={() => {
            setSelectedEmployeeId(null)
          }}
        />
      )}
    </>
  )
}
